module.exports = __webpack_public_path__ + "img/journey.6c711958.svg";